import React from 'react';
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Novurem Patisserie - Feinste Confiserie in Ettlingen</title>
        <meta name="description" content="Novurem Patisserie - Boutique Konditorei mit feinsten Pralinen, Macarons, Torten und Pralinen in Ettlingen. Handwerkskunst mit Kirschrot, Vanillecreme und Pistazie." />
      </Helmet>

      <div className="refund-policy">
      <h1>Widerrufs- und Rückgaberecht</h1>
      <p><strong>Stand: Februar 2024</strong></p>

      <section className="refund-section">
        <h2>1. Vorbemerkung</h2>
        <p>
          Wir, die <strong>Novurem Patisserie</strong> ([Straße und Hausnummer], 76275 Ettlingen, Deutschland, E-Mail: <a href="mailto:novurem@hotmail.com">novurem@hotmail.com</a>), möchten sicherstellen, dass Sie mit Ihrem Einkauf bei uns zufrieden sind. Diese Rückgabe- und Widerrufsrichtlinie informiert Sie über Ihre Rechte und die Bedingungen für Rückgaben.
        </p>
      </section>

      <section className="refund-section">
        <h2>2. Widerrufsrecht für Verbraucher</h2>
        <p>
          Verbrauchern steht grundsätzlich ein gesetzliches Widerrufsrecht von 14 Tagen zu. Dieses Widerrufsrecht gilt jedoch <strong>nicht</strong> für bestimmte Produktkategorien, insbesondere für schnell verderbliche Lebensmittel.
        </p>
      </section>

      <section className="refund-section">
        <h2>3. Ausschluss des Widerrufsrechts</h2>
        <p>
          Das Widerrufsrecht erlischt gemäß § 312g Abs. 2 BGB bei folgenden Verträgen:
        </p>
        
        <h3>3.1 Schnell verderbliche Waren</h3>
        <p>
          Das Widerrufsrecht erlischt bei Verträgen zur Lieferung von Waren, die schnell verderben können oder deren Verfallsdatum schnell überschritten würde (§ 312g Abs. 2 Nr. 2 BGB).
        </p>
        <p>
          Da es sich bei unseren Produkten um <strong>frische, handgefertigte Patisserie-Produkte</strong> handelt (Pralinen, Macarons, Torten, Gebäck), die aus hygienischen und gesundheitlichen Gründen nicht zurückgenommen werden können, ist ein Widerruf nach Erhalt nicht möglich.
        </p>

        <h3>3.2 Versiegelte Waren aus Gesundheits- oder Hygieneschutzgründen</h3>
        <p>
          Das Widerrufsrecht erlischt bei Verträgen zur Lieferung versiegelter Waren, die aus Gründen des Gesundheitsschutzes oder aus Hygienegründen nicht zur Rückgabe geeignet sind, wenn ihre Versiegelung nach der Lieferung entfernt wurde (§ 312g Abs. 2 Nr. 2 BGB).
        </p>

        <h3>3.3 Individuell angefertigte Produkte</h3>
        <p>
          Das Widerrufsrecht erlischt bei Verträgen zur Lieferung von Waren, die nach Kundenspezifikationen angefertigt werden oder eindeutig auf die persönlichen Bedürfnisse zugeschnitten sind (§ 312g Abs. 2 Nr. 1 BGB).
        </p>
        <p>
          Dies betrifft insbesondere <strong>individuell gestaltete Torten und Sonderanfertigungen</strong>.
        </p>
      </section>

      <section className="refund-section">
        <h2>4. Rückgaberecht für nicht verderbliche Produkte</h2>
        <p>
          Für folgende nicht verderbliche Produkte gilt das gesetzliche Widerrufsrecht von 14 Tagen:
        </p>
        <ul>
          <li>Gutscheine (sofern nicht eingelöst und nicht abgelaufen)</li>
          <li>Leere Geschenkverpackungen</li>
          <li>Non-Food-Artikel (z.B. Merchandise-Produkte)</li>
        </ul>

        <h3>4.1 Widerrufsfrist</h3>
        <p>
          Die Widerrufsfrist beträgt 14 Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die letzte Ware in Besitz genommen haben.
        </p>

        <h3>4.2 Ausübung des Widerrufs</h3>
        <p>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns
        </p>
        <address>
          Novurem Patisserie<br />
          [Straße und Hausnummer]<br />
          76275 Ettlingen<br />
          Deutschland<br />
          E-Mail: info@novurem.com<br />
          Telefon: [Telefonnummer]
        </address>
        <p>
          mittels einer eindeutigen Erklärung (z.B. per E-Mail oder Brief) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Zur Wahrung der Widerrufsfrist genügt es, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
        </p>

        <h3>4.3 Widerrufsfolgen</h3>
        <p>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen 14 Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
        </p>
        <p>
          Für die Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart.
        </p>
        <p>
          Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben.
        </p>

        <h3>4.4 Rücksendung der Waren</h3>
        <p>
          Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen 14 Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrags unterrichten, an uns zurückzusenden oder zu übergeben. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von 14 Tagen absenden.
        </p>
        <p>
          Sie tragen die unmittelbaren Kosten der Rücksendung der Waren.
        </p>
      </section>

      <section className="refund-section">
        <h2>5. Mängelrüge und Reklamationen</h2>
        
        <h3>5.1 Transportschäden</h3>
        <p>
          Unsere Produkte werden sorgfältig verpackt und versendet. Sollten Sie dennoch einen Transportschaden feststellen, bitten wir Sie:
        </p>
        <ul>
          <li>Melden Sie den Schaden innerhalb von <strong>48 Stunden nach Erhalt</strong> per E-Mail an <a href="mailto:novurem@hotmail.com">novurem@hotmail.com</a></li>
          <li>Fügen Sie Fotos des beschädigten Produkts und der Verpackung bei</li>
          <li>Bewahren Sie die Originalverpackung auf</li>
        </ul>
        <p>
          Nach Prüfung der Reklamation erhalten Sie Ersatz oder eine Gutschrift.
        </p>

        <h3>5.2 Qualitätsmängel</h3>
        <p>
          Sollte ein Produkt nachweislich einen Qualitätsmangel aufweisen (z.B. Verunreinigungen), kontaktieren Sie uns bitte innerhalb von 48 Stunden nach Erhalt unter <a href="mailto:novurem@hotmail.com">novurem@hotmail.com</a>. Bitte fügen Sie Fotos bei und beschreiben Sie den Mangel.
        </p>
        <p>
          Wir werden die Reklamation schnellstmöglich bearbeiten und Ihnen entweder Ersatz liefern oder den Kaufpreis erstatten.
        </p>

        <h3>5.3 Allergene und Unverträglichkeiten</h3>
        <p>
          Wir weisen darauf hin, dass unsere Produkte in einer Küche hergestellt werden, in der Allergene wie Gluten, Nüsse, Milch, Eier, Soja und Sesam verarbeitet werden. Es kann daher zu Spurenkontaminationen kommen. Eine Haftung für allergische Reaktionen wird ausgeschlossen.
        </p>
      </section>

      <section className="refund-section">
        <h2>6. Erstattungsbedingungen</h2>
        
        <h3>6.1 Erstattungswege</h3>
        <p>
          Erstattungen werden auf dem ursprünglichen Zahlungsweg vorgenommen. Alternativ können wir auf Wunsch eine Gutschrift ausstellen.
        </p>

        <h3>6.2 Bearbeitungszeit</h3>
        <p>
          Erstattungen werden innerhalb von 14 Tagen nach Eingang der Rückgabe bzw. nach Anerkennung der Reklamation bearbeitet.
        </p>

        <h3>6.3 Versandkosten bei Reklamationen</h3>
        <p>
          Bei berechtigten Reklamationen (Qualitätsmangel, Transportschaden) übernehmen wir die Kosten für den Rückversand.
        </p>
      </section>

      <section className="refund-section">
        <h2>7. Stornierung von Bestellungen</h2>
        
        <h3>7.1 Stornierung vor Versand</h3>
        <p>
          Sie können Ihre Bestellung stornieren, solange sie noch nicht versandt wurde. Senden Sie hierfür eine E-Mail an <a href="mailto:novurem@hotmail.com">novurem@hotmail.com</a> mit Ihrer Bestellnummer.
        </p>
        <p>
          Bereits geleistete Zahlungen werden vollständig erstattet.
        </p>

        <h3>7.2 Stornierung nach Versand</h3>
        <p>
          Nach dem Versand ist eine Stornierung nicht mehr möglich. Es gelten die Bedingungen der Rückgabe- und Widerrufsrichtlinie.
        </p>
      </section>

      <section className="refund-section">
        <h2>8. Besondere Bestimmungen für Torten und Sonderanfertigungen</h2>
        <p>
          (1) Individuell gefertigte Torten und Sonderanfertigungen sind vom Widerruf ausgeschlossen.
        </p>
        <p>
          (2) Bei Torten mit individueller Gestaltung (z.B. personalisierte Motive, besondere Deko) wird eine Anzahlung von 50% des Kaufpreises fällig. Diese Anzahlung wird bei Stornierung des Auftrags einbehalten, wenn die Produktion bereits begonnen hat.
        </p>
        <p>
          (3) Abweichungen vom gewünschten Design sind möglich, sofern die Gestaltung handwerklich bedingt ist. Dies stellt keinen Mangel dar.
        </p>
        <p>
          (4) Bei Beschwerden über das Design einer Sonderanfertigung entscheidet der Verkäufer nach pflichtgemäßem Ermessen über eine angemessene Lösung (Nachbesserung, Teilerstattung).
        </p>
      </section>

      <section className="refund-section">
        <h2>9. Rückgabe von Produkten</h2>
        <p>
          Aus hygienischen Gründen und wegen der Verderblichkeit unserer Produkte können wir <strong>keine Rückgabe von geöffneten oder angebrochenen Produkten</strong> akzeptieren.
        </p>
        <p>
          Bei defekten oder falsch gelieferten Produkten kontaktieren Sie uns bitte innerhalb von 48 Stunden nach Erhalt. Wir senden Ihnen ein Retourenlabel zu und ersetzen das Produkt nach Rücksendung.
        </p>
      </section>

      <section className="refund-section">
        <h2>10. Kontakt für Rückgaben und Reklamationen</h2>
        <address>
          Novurem Patisserie<br />
          [Straße und Hausnummer]<br />
          76275 Ettlingen<br />
          Deutschland<br />
          E-Mail: info@novurem.com<br />
          Telefon: [Telefonnummer]
        </address>
        <p>
          Bitte geben Sie bei allen Anfragen Ihre Bestellnummer an, um die Bearbeitung zu beschleunigen.
        </p>
      </section>

      <section className="refund-section">
        <h2>11. Alternative Streitbeilegung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie hier finden: <a href="https://ec.europa.eu/consumers/odr/">https://ec.europa.eu/consumers/odr/</a>.
        </p>
        <p>
          Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section className="refund-section">
        <h2>12. Finale Hinweise</h2>
        <p>
          (1) Diese Rückgabepolitik gilt in Verbindung mit unseren AGB.
        </p>
        <p>
          (2) Wir behalten uns vor, diese Rückgabepolitik zu aktualisieren. Die jeweils aktuelle Version ist auf unserer Website verfügbar.
        </p>
      </section>
    </div>
  
    </>);
};

export default RefundPolicy;